import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { COMPETITION_URL } from 'app/@common/constants'


export default function SelectRooms({...props}) {

    const myProps = {
        urlAjax: COMPETITION_URL.ROOMS,
        placeholder: 'All rooms',
        isClearable: true,
        isMulti: true,
        icon: { icon: 'bed' },
        styles: {
            option: (styles, { data }) => {
                return {
                    ...styles,
                    backgroundColor: !data.isMain ? undefined : '#E3E8F2',
                    color: !data.isMain ? undefined : '#808080',
                }
            },
            menuPortal: (base) => ({ ...base, zIndex: 2000 }),
        },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}